import { PRODUCTION, STAGING, DEVELOPMENT, LOCAL } from "../../constants/environment";
var getMixPanelConfig = function (env) {
    switch (env) {
        case PRODUCTION:
            return "db23a499d137c41fe1659f21e2b6cadf";
        case STAGING:
            return "f0fba8b7964575c06ac542ae54e98ed7";
        case LOCAL:
        case DEVELOPMENT:
            return "6b4f69bfbe4249979741478bdd64b494";
        default:
            return null;
    }
};
export default (function (env) { return ({
    mixpanel: getMixPanelConfig(env)
}); });
